var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRfSignallevel3 = function SvgRfSignallevel3(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3790",
    width: 16,
    height: 16,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer3",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4522",
    d: "m.222 5.36 1.06 1.062a9.5 9.5 0 0 1 13.436 0l1.06-1.061c-4.296-4.296-11.26-4.296-15.556 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4526",
    d: "m2.343 7.482 1.06 1.06a6.5 6.5 0 0 1 9.193 0l1.06-1.06a8 8 0 0 0-11.313 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4530",
    d: "m4.465 9.604 1.06 1.06a3.5 3.5 0 0 1 4.95 0l1.06-1.06a5 5 0 0 0-7.07 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4559",
    d: "M39 7.938a1.938 2.063 0 1 1-3.875 0 1.938 2.063 0 1 1 3.875 0",
    transform: "matrix(.77419 0 0 .72727 -20.694 6.588)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRfSignallevel3);
export default ForwardRef;